export const BREEZE_MAGENTA = '#d20688';
export const BREEZE_NEUTRAL_WHITE = '#FFFFFF';
export const BREEZE_GRADIENT_DARK = 'linear-gradient(114deg, #9778ec 10.79%, #d20688 61.66%, #ff4800 98.02%)';
export const BREEZE_GRADIENT_DARK_TRIPLE = 'linear-gradient(114deg, #9778ec 3.5966%, #d20688 20.55%, #ff4800 32.67%, #9778ec 67.32%, #d20688 87.22%, #ff4800 99.33%)';
export const BREEZE_GRADIENT_LIGHT = 'linear-gradient(99deg, #FBDDD2 23.32%, #FBDBE9 47.71%, #EFEEFD 77.29%)';
export const BREEZE_GRADIENT_LIGHT_TRIPLE = 'linear-gradient(99deg, #FBDDD2 23.32%, #FBDBE9 47.71%, #EFEEFD 77.29%, #FBDDD2 23.32%, #FBDBE9 47.71%, #EFEEFD 77.29%)';
export const BREEZE_MAGENTA_HOVER = '#A5016A';
export const BREEZE_MAGENTA_ACTIVE = '#8A005D';
export const BREEZE_SECONDARY_BACKGROUND_HOVER = '#FCEBF2';
export const BREEZE_SECONDARY_BACKGROUND_ACTIVE = '#FBDBE9';
export const BREEZE_NEUTRAL_BLACK = '#33475B';
export const BREEZE_NEUTRAL_BLACK_HOVER = '#516F90';
export const BREEZE_NEUTRAL_BLACK_ACTIVE = '#33475B';
export const BREEZE_PLAIN_LOADER = '#EAF0F6';